import { useState, useEffect } from 'react';
import { listLawftIds } from 'services/Settings';
import { useUserDetailsContext } from 'context/userDetailsContext';

export default function useLawftIdList() {
  const [lawftIds, setLawftIds] = useState([]);
  const [lawftIdData, setLawftIdData] = useState(null);
  const [sortOrder, setSortOrder] = useState('alphabet_ascending');
  const [pageLimit, setPageLimit] = useState(10);
  const userDetails = useUserDetailsContext();

  useEffect(() => {
    const initialPageLimit = userDetails?.firmDetails?.pagination_preference?.settings?.custom_descriptors?.lawft_ids || 10;
    setPageLimit(initialPageLimit);
    loadLawftIds(initialPageLimit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPageLimit(userDetails?.firmDetails?.pagination_preference?.settings?.custom_descriptors?.lawft_ids || 10);
  }, [userDetails]);

  const loadLawftIds = (limit = pageLimit, pagination_token = '', pagination_direction = 'forward', sort_order = sortOrder) => {
    listLawftIds(limit, pagination_token, pagination_direction, '', {}, sort_order).then((response) => {
      setLawftIds(response?.data?.lawft_id || []);
      setLawftIdData(response?.data);
    });
  };

  const onSortChange = (newSortOrder) => {
    setSortOrder(newSortOrder);
    loadLawftIds(pageLimit, '', 'forward', newSortOrder);
  };

  return { loadLawftIds, lawftIds, lawftIdData, sortOrder, onSortChange, pageLimit };
}
